import React from 'react';
import PropTypes from 'prop-types';
import styles from './CountTop.module.scss';

function CountTop(props) {
  return (
    <div className={styles.container}>
      <p>{props.title}</p>
      <span className={styles.count}>{props.count}</span>
    </div>
  );
}

export default CountTop;

CountTop.defaultProps = {
  count: 0,
};

CountTop.propTypes = {
  title: PropTypes.string.isRequired,
  count: PropTypes.number,
};
